import { inject, observer } from "mobx-react";
import React, { useEffect } from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { IPaymentStore } from "../../../models/payments/PaymentStore";
import styles from "./paymentSummary.css";

interface Props {
  agentsNumber: number;
  planPrice: number;
  currency: string;
  country?: string;
  companyId?: string;
  paymentStore?: IPaymentStore;
}

export const PaymentSummary = inject("paymentStore")(
  observer(({ agentsNumber, planPrice, currency, country, companyId, paymentStore }: Props) => {
    const priceWithoutVat = agentsNumber * planPrice;

    useEffect(() => {
      if (paymentStore && country) {
        paymentStore.getTaxRate(country, companyId);
      }
    }, []);

    useEffect(() => {
      if (paymentStore && country && companyId) {
        paymentStore.getTaxRate(country, companyId);
      }
    }, [country, companyId]);

    const getVatAmount = () => {
      const { taxRate } = paymentStore!;
      const rawVat = taxRate && agentsNumber * planPrice * taxRate;
      return rawVat ? Math.round(rawVat * 100) / 100 : 0;
    };

    const vat = getVatAmount();

    return (
      <div className={styles["payment-summary-container"]}>
        <table>
          <tbody>
            <tr>
              <td>
                {intl.formatMessage("signup.payment.users", {
                  number: agentsNumber,
                  price: intl.formatPrice(planPrice, currency)
                })}
              </td>
              <td>{intl.formatPrice(priceWithoutVat, currency)}</td>
            </tr>
            {paymentStore !== undefined && !!paymentStore.taxRate && (
              <tr>
                <td>
                  {intl.formatMessage("signup.payment.VAT", {
                    vat: intl.formatNumber(paymentStore.taxRate, { style: "percent" })
                  })}
                </td>
                <td>{intl.formatPrice(getVatAmount(), currency)}</td>
              </tr>
            )}
          </tbody>
        </table>
        <hr />
        <div>
          <span className={styles["summary-price"]}>
            {intl.formatPrice(vat + priceWithoutVat, currency)}
          </span>
          <span className={styles["summary-month"]}>
            {intl.formatMessage("signup.payment.perMonth")}
          </span>
        </div>
      </div>
    );
  })
);
